import { IGame, IPlayer } from "../../interfaces";
import { Phase } from "../../util/enums";

const solutionCardsInitialVisibility = (game: IGame | undefined, userData: IPlayer | undefined) => {

    if (userData && game?.phase === Phase.CHOOSING_SOLUTION_CARDS && !game.gameInfo.players[userData.email]?.hasDrawnSolutionCards) {
        return true;
    }

    return false;
}

export default solutionCardsInitialVisibility;